import React from 'react';
import { Link } from 'react-router-dom';
import './Lunch.css';
import LunchHeroImage from '../assets/img/lunch-hero.webp';
import { Seo, buildBreadcrumbSchema } from '../components/Seo';
import {
  formatLunchDate,
  getFeaturedLunchOffer,
  getUpcomingLunchOffers,
  getZurichTodayIso,
  lunchMenuPdf,
  lunchOffers
} from '../data/lunchOffers';

function Lunch() {
  const referenceDate = new Date();
  const todayIso = getZurichTodayIso(referenceDate);
  const featuredLunch = getFeaturedLunchOffer(referenceDate);
  const upcomingOffers = getUpcomingLunchOffers(todayIso);
  const visibleOffers = upcomingOffers.length > 0 ? upcomingOffers : lunchOffers;

  return (
    <div className='lunch-page'>
      <Seo
        title='Mittagessen'
        description='Mittagessen bei Sarita&apos;s in Hinwil mit wechselnden Tagesgerichten, Monatsplan und weiteren Mittagsoptionen aus der regulären Speisekarte.'
        path='/lunch'
        schema={[
          buildBreadcrumbSchema([
            { name: 'Startseite', path: '/' },
            { name: 'Mittagessen', path: '/lunch' }
          ])
        ]}
      />
      <header
        className='page-hero lunch-hero'
        style={{ backgroundImage: `url(${LunchHeroImage})` }}
      >
        <div className='container page-hero__content lunch-hero__content'>
          <h1 className='page-hero__title'>Mittagessen</h1>
          <p className='lunch-hero__text'>
            Unsere Tagesgerichte gibt es an ausgewählten Tagen. Zusätzlich ist die reguläre Speisekarte auch über Mittag verfügbar.
          </p>
        </div>
      </header>

      <section className='section-shell'>
        <div className='container lunch-layout'>
          <div className='lunch-primary reveal'>
            <section className='lunch-feature panel-surface' aria-labelledby='lunch-feature-title'>
              <p className='section-eyebrow'>Tagesgericht</p>
              <h2 id='lunch-feature-title'>{featuredLunch.label}</h2>
              {featuredLunch.offer ? (
                <>
                  <p className='lunch-feature__date'>
                    {formatLunchDate(featuredLunch.offer.date)}
                  </p>
                  <p className='lunch-feature__title'>{featuredLunch.offer.title}</p>
                  {featuredLunch.offer.price ? (
                    <p className='lunch-feature__price'>{featuredLunch.offer.price}</p>
                  ) : null}
                  {featuredLunch.offer.detail ? (
                    <p className='lunch-feature__detail'>{featuredLunch.offer.detail}</p>
                  ) : null}
                </>
              ) : (
                <p className='lunch-feature__detail'>
                  Die nächsten Tagesgerichte werden bald aktualisiert.
                </p>
              )}
              <div className='lunch-feature__actions'>
                <a className='btn-sarita' href={lunchMenuPdf} target='_blank' rel='noreferrer'>
                  Monatsplan November PDF öffnen
                </a>
                <a className='btn-sarita btn-sarita--ghost' href={lunchMenuPdf} download>
                  Monatsplan November PDF herunterladen
                </a>
              </div>
            </section>

            <section className='lunch-regular panel-surface' aria-labelledby='lunch-regular-title'>
              <p className='section-eyebrow'>Immer über Mittag</p>
              <h2 id='lunch-regular-title'>Weitere Mittagsoptionen</h2>
              <p>
                Neben den Tagesgerichten servieren wir über Mittag auch Gerichte aus der regulären Speisekarte.
              </p>
              <Link className='btn-sarita btn-sarita--ghost lunch-regular__link' to='/menu'>
                Speisekarte ansehen
              </Link>
            </section>
          </div>

          <section className='lunch-list panel-surface reveal' aria-labelledby='lunch-list-title'>
            <div className='lunch-list__header'>
              <p className='section-eyebrow'>Übersicht</p>
              <h2 id='lunch-list-title'>Kommende Tagesgerichte</h2>
              <p className='lunch-list__text'>
                Diese wechselnden Gerichte sind an den aufgeführten Tagen erhältlich.
              </p>
            </div>
            <div className='lunch-list__items'>
              {visibleOffers.map((offer) => {
                const isToday = offer.date === todayIso;
                const isPast = offer.date < todayIso;

                return (
                  <article
                    className={`lunch-item ${isToday ? 'is-today' : ''} ${isPast ? 'is-past' : ''}`}
                    key={offer.date}
                  >
                    <time className='lunch-item__date' dateTime={offer.date}>
                      {formatLunchDate(offer.date, { weekday: 'short' })}
                    </time>
                    <div className='lunch-item__body'>
                      <h3>{offer.title}</h3>
                      {offer.detail ? <p>{offer.detail}</p> : null}
                    </div>
                    <div className='lunch-item__meta'>
                      {offer.price ? <span className='lunch-item__price'>{offer.price}</span> : null}
                      {isToday ? <span className='lunch-item__badge'>Heute</span> : null}
                    </div>
                  </article>
                );
              })}
            </div>
          </section>
        </div>
      </section>
    </div>
  );
}

export default Lunch;
